<template>
	<el-dialog title="关闭备注" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="40%"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div class="grid-height">

					<div class="table_main">
						<el-input
  type="textarea"
  :autosize="{ minRows:10, maxRows: 10}"
  placeholder="请输入内容"
  v-model="textarea2">
</el-input>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param', 'checkSubjectId'],
	mixins: [selectDialogMixins],
	components: { },

  created() {
    if (this.checkSubjectId !== '') {
      this.formData.checkSubjectId = this.checkSubjectId
    }
  },
	data() {
		return {
			textarea2: '',
			data: [],
			dataId: 0,
			showEdit: false,
			vxeOption: {},
      isRouterAlive: true,
			// 查询参数
			formData: {
			},
			showDialog: true,
			falseValue: false,
			selectMulti: true,
      searchOrderNo: '',
      selectedRow: {
        id: '', orderNo: ''
      }
		};
	},


	methods: {
		commitRow(){
			this.showDialog=false
		},
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },
	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 200px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}
  ::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
    font-size: 14px !important;
}
</style>
